import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export default function DownloadButton({ onPdf, onPng, onCsv, style }) {
  const items = [];
  if (onPdf) items.push({ key: 'pdf', label: 'Download PDF', onClick: onPdf });
  if (onPng) items.push({ key: 'png', label: 'Download PNG', onClick: onPng });
  if (onCsv) items.push({ key: 'csv', label: 'Download CSV', onClick: onCsv });

  if (items.length > 1) {
    return <Dropdown menu={{ items }} placement="bottomRight">
      <Button icon={<DownloadOutlined />} size="small" style={style} />
    </Dropdown>;
  }
  if (items.length === 1) {
    return <Button icon={<DownloadOutlined />} size="small" onClick={items[0].onClick} style={style} />;
  }
  return null;
}
